import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ConfigService } from '../services/config.service';
import * as i0 from "@angular/core";
import * as i1 from "../services/config.service";
import * as i2 from "@angular/router";
export class ReferralGuard {
    constructor(configService, router) {
        this.configService = configService;
        this.router = router;
        this.loader$ = new Subject();
        this.loader = false;
        this.loader$.pipe(debounceTime(300)).subscribe(loader => { this.loader = loader; });
    }
    canActivate(next, state) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.setShowLoader(true);
            yield this.configService.getInitialInfo();
            this.setShowLoader(false);
            if (this.configService.company_info.referral_module)
                return true;
            this.router.navigateByUrl('/autenticacion');
            return false;
        });
    }
    setShowLoader(show) {
        this.loader$.next(show);
    }
}
ReferralGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ReferralGuard_Factory() { return new ReferralGuard(i0.ɵɵinject(i1.ConfigService), i0.ɵɵinject(i2.Router)); }, token: ReferralGuard, providedIn: "root" });
